import React from "react";

import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';

const PlusButton = (props)=>{
    return(
        <FloatingActionButton 
            className="btn-plus" 
            iconStyle={{height: 20, width: 20}} 
			disabled={props.disabled} 
            mini={props.mini} 
            style={props.styles} 
            onClick={()=>props.action()}
        >
			<ContentAdd/>
		</FloatingActionButton>  
    )
}

export default PlusButton;

PlusButton.defaultProps = {
    mini:true,
    disabled:false,
    styles:{}
}